module.exports = __webpack_public_path__ + "img/bg-3.d5fc534e.jpg";